import React from "react"
import { useSearchParams } from "react-router-dom"
import { ChildrenProps } from "../../../@types/CapioWeb/core"

export interface PaginationContextValue {
	activePage: string
	setActivePage: React.Dispatch<React.SetStateAction<string>>
}

export const PaginationContext = React.createContext<PaginationContextValue>({
	activePage: null,
	setActivePage: () => null,
})

export const PaginationContextProvider: React.FC<ChildrenProps> = ({
	children,
}) => {
	const getActivePageFromSearchParams = (name: string) => {
		const [searchParams] = useSearchParams()
		const value = searchParams.get(name)
		if (!value) return "1"

		// Filter out invalid options
		return value
	}

	const [activePage, setActivePage] = React.useState<string>(
		getActivePageFromSearchParams("page")
	)

	React.useEffect(() => {
		const url = new URL(window.location.href)

		url.searchParams.set("page", activePage.toString())

		window.history.replaceState({}, "", url)
	}, [activePage])

	return (
		<PaginationContext.Provider
			value={{
				activePage,
				setActivePage,
			}}
		>
			{children}
		</PaginationContext.Provider>
	)
}
